import React, { createContext, useContext, useMemo } from 'react';

import PropTypes from 'prop-types';
/**
 * BuilderHamburgerMenuContext
 * @returns { closeNav }
 * */

const Context = createContext();

export const useBuilderHamburgerMenuContext = () => useContext(Context);

const BuilderHamburgerMenuProvider = ({ children, closeNav }) => {
  const value = useMemo(
    () => ({
      closeNav,
    }),
    [closeNav]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

BuilderHamburgerMenuProvider.propTypes = {
  children: PropTypes.node,
  closeNav: PropTypes.func,
};

export default BuilderHamburgerMenuProvider;
